/**
 * The pinned bottom of the item editor: what is in the way of saving (or what
 * saving will do), Cancel, and Save — and, after a save that forked a
 * revision, the sentence saying so with a single Done.
 */
export function EditorFooter({
  error,
  blocked,
  forksTo,
  saving,
  label,
  onCancel,
  onSave,
}: {
  error: string | null
  blocked: boolean
  /** The revision a save will create, when it will fork one. */
  forksTo: string | null
  saving: boolean
  label: string
  onCancel: () => void
  onSave: () => void
}): JSX.Element {
  return (
    <>
      <span className="ie-foot__status">
        {error !== null ? (
          <span className="critical">{error}</span>
        ) : blocked ? (
          <span className="critical">Fix the fields marked in red, then save.</span>
        ) : forksTo !== null ? (
          <span className="warn">Saving creates {forksTo}</span>
        ) : null}
      </span>
      <button type="button" onClick={onCancel}>
        Cancel
      </button>
      <button type="button" className="primary" disabled={saving} onClick={onSave}>
        {saving ? 'Saving…' : label}
      </button>
    </>
  )
}

/** After a save that forked: the old revision was left alone, and why. */
export function ForkedDone({ from, to }: { from: string | null; to: string }): JSX.Element {
  return (
    <div className="ie-done">
      <strong>Saved as {to}.</strong>
      <p>
        {from ?? 'The previous revision'} had already been used, so it was left exactly as it was — what was built to it still says
        what it was made of. Everything from now on uses {to}.
      </p>
    </div>
  )
}
